// Generated by CoffeeScript 1.9.2
module.exports = function(q, option) {
  return (q != null ? q.__q : void 0) === 'options' && ((q != null ? q.__p[option] : void 0) != null);
};
